import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IconName, GridComponent, HeadingComponent } from '@sirius/common';
import { DownloadItem, DownloadItemsComponent } from 'commerce/models';
import { FileDownloadCardComponent } from '../file-download-card/file-download-card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'commerce-file-download-list',
    templateUrl: './file-download-list.component.html',
    styleUrls: ['./file-download-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GridComponent, HeadingComponent, FileDownloadCardComponent, TranslatePipe]
})
export class FileDownloadListComponent implements OnInit {
    @Input()
    downloadItems?: DownloadItem[] = [];

    @Input()
    title?: string;

    config?: DownloadItemsComponent;

    ngOnInit(): void {
        if (this.config) {
            this.title = this.config.title;
            this.downloadItems = this.config.downloadItems;
        }
    }

    getIconName(fileExtension: string): IconName {
        const iconMap: { [key: string]: IconName } = {
            pdf: 'file_pdf',
            doc: 'file_doc',
            docx: 'file_doc',
            xls: 'file_xls',
            xlsx: 'file_xls',
            jpg: 'file_jpg',
            png: 'file_png',
            html: 'file_html',
            ppt: 'file_ppt',
            zip: 'file_zip',
        };
        return iconMap[fileExtension] || 'file_arrow_down_duotone';
    }

    downloadFile(link: string): void {
        window.open(link, '_blank');
    }
}
